import './vendor';
import './helpers';
import background from './modules/bg/_background';
import init from './modules/textScrumble/_textScrumble';
import about from './modules/about/_aboutMe';
import works from './modules/works/_works';

window.addEventListener('DOMContentLoaded', () => {
	background();
	init();
	about('.header__items','.helloText', '.about', '.works', '.sertify', '.contact');
	works('.works__img')
})